import * as React from 'react';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Paper, Typography, LinearProgress } from '@material-ui/core';
import { GetCacheIfExists, SetDataToSession } from '../../../shared/cache/Cache';

// tslint:disable-next-line:no-empty-interface
export interface IPublisherRevenueComparativeProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IPublisherRevenueComparativeState {

}

const PUBLISHER_REVENUE_COMPARATIVE = gql`
{
	publisherAveragePrice {
		current_year,
		last_year
	}
}
`;

export class PublisherRevenueComparative extends React.Component<IPublisherRevenueComparativeProps, IPublisherRevenueComparativeState> {
    public render() {

        let dataCache = GetCacheIfExists('publisher-data');

        if( dataCache != null && dataCache.publisherAveragePrice != null ) {
            return this.dataToRend(dataCache, false);
        } else {
            return (
                <Query query={PUBLISHER_REVENUE_COMPARATIVE}>
                    {({ loading, error, data }) => {

                        if ( data != null && data.publisherAveragePrice != null ) {
                            if(dataCache != null && dataCache !== undefined) {
                                dataCache.publisherAveragePrice = data.publisherAveragePrice;
                            } else {
                                dataCache = data;
                            }
                            SetDataToSession('publisher-data', dataCache);
                        }

                        return this.dataToRend(data,loading);
                    }}
                </Query>
            );
        }

    }

    /**
     * Método utilizado para renderizar as informações do card
     * Foi destacado do restante do código para que seja reutilizado nas requisições de cache e do graphql
     */
    private dataToRend (data:any, loading:any) {
        return (
            <Paper className="publisher-sale-block panel-block">
                <Typography variant="headline" className="panel-title" component="title">
                    Comparativo de Faturamento
                </Typography>
                {loading && <LinearProgress />}
                <Typography component="p">
                    {data.publisherAveragePrice && data.publisherAveragePrice[0].current_year}
                </Typography>
            </Paper>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/publisher/sale/revenue-comparative/PublisherRevenueComparative.tsx